import { securityOptions } from '../config/securityOptions';

/**
 * Payment docs require a Bearer token and resolve to a short-lived S3 URL.
 * Request JSON (`{ url }`) so we never fetch-follow the 302 into S3 (CORS).
 * Then navigate with window.open — no CORS needed.
 */
export async function openAuthenticatedDoc(absolutePath: string): Promise<void> {
  const token = securityOptions.getLoginAsToken() || localStorage.getItem('id_token');
  const url = absolutePath.startsWith('http')
    ? absolutePath
    : `${window.location.origin}${absolutePath}`;

  if (!token) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error(`Unable to open document (${res.status})`);
  }

  const body = (await res.json()) as { url?: string };
  if (!body?.url) {
    throw new Error('Unable to open document (missing url)');
  }

  window.open(body.url, '_blank', 'noopener,noreferrer');
}
